import { useEffect } from "react";

const ChatWootWidget = ({ empresa }) => {
  useEffect(() => {
    const BASE_URL = "https://chatwoot.podiumeducacao.com.br";
    const scriptId = "chatwoot-script";

    window.chatwootSettings = {
      hideMessageBubble: false,
      position: "right",
      locale: "pt_BR",
      type: "standard",
    };

    if (!document.getElementById(scriptId)) {
      (function(d, t) {
        var g = d.createElement(t),
          s = d.getElementsByTagName(t)[0];
        g.src = BASE_URL + "/packs/js/sdk.js";
        g.id = scriptId;
        g.defer = true;
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          window.chatwootSDK.run({
            websiteToken: "RLAYQq4ZXoGpD4gfHjJLBjGb",
            baseUrl: BASE_URL,
          });
        };
      })(document, "script");
    } else if (
      window.$chatwoot &&
      typeof window.$chatwoot.toggleBubbleVisibility === "function"
    ) {
      window.$chatwoot.setCustomAttributes({
        nome: empresa?.emp_nome_fantasia ?? "",
        cnpj: empresa?.emp_cnpj ?? "",
      });
      window.$chatwoot.toggleBubbleVisibility("show");
    }

    return () => {
      if (
        window.$chatwoot &&
        typeof window.$chatwoot.toggleBubbleVisibility === "function"
      ) {
        window.$chatwoot.toggleBubbleVisibility("hide");
      }
    };
  }, []);

  return null;
};

export default ChatWootWidget;
